import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useUsersStore } from '../store/usersStore'
import { completeSetup } from '../utils/completeSetup'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useCompleteUserSetupMutation = (onSuccess?: () => void) => {
  const update = useUsersStore((state) => state.update)

  return useMutation({
    mutationFn: ({ token, password }: { token: string; password: string }) => {
      if (!token) {
        throw new Error('Token not provided')
      }
      return completeSetup(token, password)
    },
    onSuccess: ({ message, user }) => {
      update(user)
      toast.success(message || 'User setup completed successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(
        error,
        'An error occurred while completing user setup.',
      )
    },
  })
}
